<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>
        <template slot="actions" slot-scope="{ item }">
            <b-button  size="sm" variant="danger" @click="removeRiskDiagnosis(item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>

export default {
    props: {
        data: {
            type: [Object, Array]
        }
    },
    data(){
        return {
            fields: [
                    {
                        key: 'file_name',
                        label: 'Archivo',
                        filter: true
                    },
                    {
                        key: 'ext',
                        label: 'Extensión',
                        filter: true
                    },
                    {
                        key: 'reported_by.name',
                        label: 'Subido por',
                        filter: true
                    },
                    {
                        key: 'notes',
                        label: 'Notas',
                        filter: true
                    },
                    {
                        key: 'created_at',
                        label: 'Fecha creación',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ],
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data.map(item => ({...item}));
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        removeRiskDiagnosis(data){
            this.$emit('remove-risk-diagnosis', data.id);
        },
    },
}
</script>